var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 0.833252C10.5766 0.833252 11.5 1.75667 11.5 2.89575V17.1041C11.5 18.2431 10.5766 19.1666 9.4375 19.1666H2.5625C1.42341 19.1666 0.5 18.2431 0.5 17.1041V2.89575C0.5 1.75667 1.42341 0.833252 2.5625 0.833252H9.4375ZM9.4375 2.20825H2.5625C2.18281 2.20825 1.875 2.51606 1.875 2.89575V17.1041C1.875 17.4838 2.18281 17.7916 2.5625 17.7916H9.4375C9.81718 17.7916 10.125 17.4838 10.125 17.1041V2.89575C10.125 2.51606 9.81718 2.20825 9.4375 2.20825ZM7.14483 15.0416C7.52451 15.041 7.83278 15.3484 7.83333 15.7281C7.83388 16.1078 7.52652 16.416 7.14684 16.4166L4.85517 16.4201C4.47549 16.4206 4.16722 16.1133 4.16667 15.7336C4.1661 15.3539 4.47348 15.0456 4.85316 15.0451L7.14483 15.0416Z",
    fill: "url(#paint0_linear_1816_1618)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1816_1618",
    x1: 0.5,
    y1: 11.1458,
    x2: 11.5,
    y2: 11.1458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.604b300fd478f928c5abe90b171e7e9f.svg";
export { ForwardRef as ReactComponent };